import { Chip } from '@material-ui/core';

const ChipComponent = ({ key = '', label = '', onClick = () => {}, className = '' }) => {
  return <Chip key={key} label={label} className={className} onClick={onClick} />;
};

export default ChipComponent;
